import { render } from "./AddGrupouView.vue?vue&type=template&id=11e000cc&scoped=true"
import script from "./AddGrupouView.vue?vue&type=script&lang=js"
export * from "./AddGrupouView.vue?vue&type=script&lang=js"

import "./AddGrupouView.vue?vue&type=style&index=0&id=11e000cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e000cc"]])

export default __exports__